// extracted by mini-css-extract-plugin
module.exports = {"content":"ContentPage_content__30CDD"};